import { IRouter } from '../type';
export const myOrders: IRouter[] = [
  {
    path: '/order',
    name: 'order',
    meta: { title: '我的订单', icon: 'el-icon-s-claim' },
    component: () => import('@/views/MyOrders/index.vue')
  }
];
